import $ from "jquery";

const button = () => {
    const init = () => {
        execute()
    }

    const execute = () => {
        const el = {
            main: '.js-button',
            menu: '.e-n-menu .e-n-menu-title-container',
            form: '.js-form .elementor-button',
            icon: '.js-icon'
        }
        if ($(el.main).length === 0) return

        const action = (thisEl, selector) => {
            const $text = thisEl.find(selector);
            $text.html(`<span>${$text.text()}</span><span aria-hidden="true">${$text.text()}</span>`)
        }

        $(el.main).each(function () {
            action($(this), '.elementor-button-text');
        });

        $(el.menu).each(function () {
            action($(this), '.e-n-menu-title-text');
        });

        $(el.form).each(function () {
            action($(this), '.elementor-button-text');
        });

        $(el.icon).each(function () {
            const $icon = $(this).find('svg');
            const $iconHTML = $icon.prop('outerHTML');
            $(this).find('.elementor-icon').append($iconHTML);
        });
    }
    init()
}

try {
    button()
} catch (error) {
    console.error('button', error)
}